import { React, useEffect } from 'react';
import { Col, Image, Row } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import YouTube from 'react-youtube';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'

import cornerDown from "../../assets/icons/products/cornerDown.svg";
import dashesBanner from "../../assets/icons/products/dashesBanner.svg";
import dashes from "../../assets/icons/products/dashes.svg";
import corner from "../../assets/icons/services/corner.svg";
import dashesService from "../../assets/icons/services/dashes.svg";

const ProductBanner = props => {
    let bannerIcon = props.page && !props.noLogo && !props.service ? require('../../assets/images/logos/logo-' + props.page + '.svg') : !props.noLogo ? require('../../assets/icons/products/' + props.page + '/banner_' + props.page + '.svg') : null;

    useEffect(() => {
        if (props.service === true) {
            props.changeLanguageColor("white")
        } else {
            props.changeLanguageColor("black")
        }
    }, [props.service])


    if (props.service) {
        return (
            <section className='ServiceBanner'>
                <div className='content '>
                    <div className='d-none d-xl-block'>
                        <Image className='corner' src={corner} />
                    </div>
                    <div className='banner-title'>
                        <div className='d-flex align-items-center'>
                            {bannerIcon ? <Image className={props.page === "mobile" ? 'mobile-icon' : ''} fluid src={bannerIcon} /> : <></>}
                            <h1 className='m-0'><Trans t={props.t} i18nKey={props.t(props.page + ':banner.title')} /></h1>
                        </div>
                    </div>
                    <div className='banner-text'>
                        <p className='m-0'>
                            <Trans t={props.t} i18nKey={props.t(props.page + ':banner.text')}
                                components={{
                                    LinkItSupport: <Link to={props.t('routes:it_support.path')}></Link>,
                                    LinkWebApplication: <Link to={props.t('routes:web.path')}></Link>,
                                    bold: <b></b>
                                }}
                            />
                        </p>
                        {props.page === "software" ?
                            <>
                                <div className='software-btns d-flex justify-content-between mt-3'>
                                    <h2>
                                        {props.t(props.page + ':banner.btn1')}
                                    </h2>
                                    <Link to={props.t("routes:web.path")}>
                                        <div><FontAwesomeIcon className='icon' icon={faAngleRight} /></div>
                                    </Link>
                                </div>
                                <div className='software-btns d-flex justify-content-between'>
                                    <h2>
                                        {props.t(props.page + ':banner.btn2')}
                                    </h2>
                                    <Link to={props.t("routes:mobile.path")}>
                                        <div><FontAwesomeIcon className='icon' icon={faAngleRight} /></div>
                                    </Link>
                                </div>
                            </>
                            : <></>
                        }
                    </div>
                    <div className='d-none d-lg-block'>
                        <Image className={props.page === "companyCertification" ? 'dashes lower' : 'dashes'} src={dashes} />
                    </div>
                </div>
            </section>
        )
    } else {
        return (
            <section className='ProductBanner'>
                <div className='content container-custom'>
                    <Row>
                        <Col sm={12} className='banner-img'>
                            <Col
                                /* xs */
                                xs={props.noLogo ? 10 : props.page === "perceptum" ? 9 : props.page === "otm" ? 5 : props.page === "meeting" ? 9 : props.page === "consilium" ? 9 : props.page === "carshare" ? 9 : 9}
                                /* sm */
                                sm={8}
                                /* md */
                                md={props.page === "perceptum" ? 7 : props.page === "otm" ? 8 : props.page === "meeting" ? 8 : props.page === "consilium" ? 8 : props.page === "carshare" ? 9 : 10}
                                /* lg */
                                lg={props.noLogo ? 10 : props.page === "perceptum" ? 6 : props.page === "otm" ? 5 : props.page === "meeting" ? 7 : props.page === "consilium" ? 6 : props.page === "carshare" ? 7 : 8}
                                /* xl */
                                xl={props.noLogo ? 10 : props.page === "perceptum" ? 4 : props.page === "otm" ? 5 : props.page === "meeting" ? 6 : props.page === "consilium" ? 5 : props.page === "carshare" ? 7 : 6}
                                /* xxl */
                                xxl={props.noLogo ? 10 : props.page === "perceptum" ? 4 : props.page === "otm" ? 6 : props.page === "meeting" ? 6 : props.page === "consilium" ? 5 : props.page === "carshare" ? 7 : 7} className={props.imgPadding ? 'logo-container d-flex img-padding' : 'logo-container d-flex'}>
                                <div className='banner-dashes d-none d-md-block'>
                                    <Image src={dashesBanner} />
                                </div>
                                {bannerIcon ? <Image fluid className='product-logo' src={bannerIcon} alt={props.t("alt:logos." + props.page)} /> : <></>}
                                {props.noLogo ? <h1 className='main-title text-uppercase m-0'><Trans t={props.t} i18nKey={props.t(props.page + ':banner.main_title')} /></h1> : null}
                            </Col>
                            <div className='cornerDown d-none d-lg-block'>
                                <Image src={cornerDown} />
                            </div>
                        </Col>
                        <Col lg={10} className='banner-title'>
                            <div className='title-container'>
                                <h1 className='m-0'>
                                    <div className='d-none d-md-block'>
                                        <span><Trans t={props.t} i18nKey={props.t(props.page + ':banner.title1')} /></span>
                                        <span><Trans t={props.t} i18nKey={props.t(props.page + ':banner.title2')} components={{ uppercase: <div className='text-uppercase'></div> }} /></span>
                                    </div>
                                    <div className='d-md-none'>
                                        <span><Trans t={props.t} i18nKey={props.t(props.page + ':banner.title1')} /> <Trans t={props.t} i18nKey={props.t(props.page + ':banner.title2')} components={{ uppercase: <div className='text-uppercase'></div> }} /></span>
                                    </div>
                                </h1>
                            </div>
                        </Col>
                    </Row>
                    <div className='banner-text'>
                        <p className='m-0'>
                            <Trans t={props.t} i18nKey={props.t(props.page + ':banner.text')}
                                components={{
                                    LinkItSupport: <Link to={props.t('routes:it_support.path')}></Link>,
                                    LinkWebApplication: <Link to={props.t('routes:web.path')}></Link>,
                                    bold: <b></b>
                                }}
                            />
                        </p>
                        {props.i18n.exists(props.page + ':banner.btn') ? <a className='btn' target='_blank' href={props.t("routes:contacts.path")}>{props.t(props.page + ':banner.btn')}</a> : <></>}
                    </div>
                    {props.i18n.exists(props.page + ':banner.videoId') ? <YouTube className='banner-video' iframeClassName='video' videoId={props.t(props.page + ':banner.videoId')} /> : null}
                    <div className='position-relative d-none d-md-block'>
                        <Image className={props.page === "consilium" ? 'dashes lower' : 'dashes'} src={dashesService} />
                    </div>
                </div>
            </section >
        )
    }
}

export default ProductBanner;